import { render, staticRenderFns } from "./TraxAccountAuthPasswordEmail.vue?vue&type=template&id=4a81febb"
import script from "./TraxAccountAuthPasswordEmail.vue?vue&type=script&lang=js"
export * from "./TraxAccountAuthPasswordEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports